export const SET_USER = 'SET_USER';
export const SET_USER_FIELD = 'SET_USER_FIELD';
export const RESET_USER_FIELDS = 'RESET_USER_FIELDS';
